import type { CSSProperties } from 'react'

type DottedBgProps = {
  bg?: string // e.g. "#001d6c" from CMS
  dots?: string // e.g. "#0946c3" from CMS
  dotSize?: string // e.g. "40px 40px" (optional)
  topInset?: string // e.g. "12px" (optional)
  leftInset?: string // e.g. "8px"  (optional)
  className?: string
  children?: React.ReactNode
}

export function DottedBg({
  bg,
  dots,
  dotSize,
  topInset,
  leftInset,
  className = '',
  children,
}: DottedBgProps) {
  type DottedVars = Partial<
    Record<'--bg' | '--dot' | '--dot-size' | '--inset-top' | '--inset-left', string>
  >

  const style: CSSProperties & DottedVars = {
    ...(bg ? { '--bg': bg } : {}),
    ...(dots ? { '--dot': dots } : {}),
    ...(dotSize ? { '--dot-size': dotSize } : {}),
    ...(topInset ? { '--inset-top': topInset } : {}),
    ...(leftInset ? { '--inset-left': leftInset } : {}),
  }

  return (
    <div className={`dotted-bg ${className}`} style={style}>
      {children}
    </div>
  )
}
